import { render, staticRenderFns } from "./SupportAttachFiles.vue?vue&type=template&id=5bba4d5e&"
import script from "./SupportAttachFiles.vue?vue&type=script&lang=ts&"
export * from "./SupportAttachFiles.vue?vue&type=script&lang=ts&"
import style0 from "./SupportAttachFiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports